export default function Open() {
  window.location.href = "/api/download";

  return null;
}
